import React from 'react';
import { UserModel } from '../../../mobx/models/user';
import DropdownItem from '../../Dropdown/DropdownItem';
import { AssignBottom, BlankDiv } from './styles';

interface AssigneeDropdownContentProps {
  data: UserModel[];
  currentIndex?: number;
  isLoading?: boolean;
  isMultiAssignee: boolean;
  isView: boolean;
  isCreateTaskModal: boolean;
  createViewInput?: {
    filters?: {
      assign?: {
        assignees: string[];
      };
    };
  };
  createTaskInput?: {
    users?: { id: string }[];
  };
  currentTask?: {
    users?: { id: string }[];
  };
  onClickUnassignUser: () => void;
  onClickAssignUser: (user: UserModel) => void;
}

const AssigneeDropdownContent: React.FC<AssigneeDropdownContentProps> = ({
  data,
  currentIndex,
  isLoading,
  isMultiAssignee,
  isView,
  isCreateTaskModal,
  createViewInput,
  createTaskInput,
  currentTask,
  onClickUnassignUser,
  onClickAssignUser
}) => {
  return (
    <div>
      <AssignBottom>
        <DropdownItem
          label={'Unassigned'}
          onClick={onClickUnassignUser}
          iconName={'unassign-profile-icon'}
          iconSize={20}
          iconViewBox='0 0 18 18'>
          {isMultiAssignee && <BlankDiv />}
        </DropdownItem>
        {data?.map((item, index: number) => {
          const isAssigned = isView
            ? createViewInput?.filters?.assign?.assignees.includes(item.id)
            : isCreateTaskModal
            ? createTaskInput?.users?.some((user: { id: string }) => user.id === item.id)
            : currentTask?.users?.some((user: { id: string }) => user.id === item.id);
          return (
            <DropdownItem
              key={index}
              label={item?.name}
              onClick={() => !isLoading && onClickAssignUser(item)}
              isCheckBox={isMultiAssignee}
              isAvatar={true}
              avatarSrc={item?.profile_photo}
              isChecked={isAssigned}
              isActive={currentIndex === index}
              isSelected={isAssigned}
            />
          );
        })}
      </AssignBottom>
    </div>
  );
};

export default AssigneeDropdownContent;
